import React from "react";
import { useSettings } from "../../lib/useSettings";

const FALLBACK_BRANDS = [
  { name: "Marque N°1", logo_url: "" },
  { name: "Marque N°2", logo_url: "" },
  { name: "Marque N°3", logo_url: "" },
  { name: "Marque N°4", logo_url: "" },
];

export default function BrandsSection() {
  const { settings: s } = useSettings();
  const kicker = s?.brands_kicker || "Marques partenaires";
  const title = s?.brands_title || "Nous installons les leaders mondiaux";
  const brands = (s?.brands && s.brands.length > 0) ? s.brands : FALLBACK_BRANDS;
  if (brands.length === 0) return null;
  const all = [...brands, ...brands, ...brands];

  return (
    <section className="py-12 md:py-14 bg-white border-y border-[hsl(var(--border))]" data-testid="brands-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-8">
          <div className="text-xs md:text-sm uppercase tracking-[0.25em] text-[color:var(--brand-sky)] font-semibold mb-2">
            {kicker}
          </div>
          <h2 className="font-display text-2xl md:text-3xl font-bold text-[color:var(--brand-navy)]">
            {title}
          </h2>
        </div>
      </div>
      <div className="relative overflow-hidden">
        <div className="flex gap-12 md:gap-20 animate-marquee whitespace-nowrap py-4 items-center" style={{ width: "max-content" }}>
          {all.map((b, i) => (
            <div
              key={i}
              className="flex items-center justify-center min-w-[140px] md:min-w-[180px] h-16 md:h-20 grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all"
              title={b.name}
            >
              {b.logo_url ? (
                <img
                  src={b.logo_url}
                  alt={b.name}
                  className="max-h-12 md:max-h-16 w-auto object-contain"
                  loading="lazy"
                />
              ) : (
                <span className="font-display font-black text-2xl md:text-3xl text-[color:var(--brand-navy)] tracking-[0.2em]">{b.name}</span>
              )}
            </div>
          ))}
        </div>
        <div className="absolute top-0 left-0 bottom-0 w-16 md:w-24 bg-gradient-to-r from-white to-transparent pointer-events-none" />
        <div className="absolute top-0 right-0 bottom-0 w-16 md:w-24 bg-gradient-to-l from-white to-transparent pointer-events-none" />
      </div>
    </section>
  );
}
